import { action, makeObservable, observable, runInAction } from 'mobx';
import { Store } from '../../store/store';
import { StoreNode } from '../../store';
import { AuthFlowResponse } from '../../services/auth/authFlowSchema';
import { IPageState } from '../pageSchema';
import { RouteContext } from '../../routes/routeContext';
import { Error } from '../../core/error';

export class OAuthCallbackPageState
  extends StoreNode
  implements IPageState {

  constructor(store: Store) {
    super(store);
    makeObservable(this, {
      isLoading: observable,
      flowResponse: observable,
      error: observable,
      attached: action,
      detached: action,
      reset: action,
    });
  }

  isLoading = false;

  flowResponse: AuthFlowResponse | null = null;
  error: Error | null = null;

  async attached(routeContext: RouteContext) {

    this.reset();
    this.isLoading = true;

    const [res, err] = await this.store.authService.handleOAuthCallback(routeContext);
    runInAction(() => {
      if (err)
        this.error = err;
      else
        this.flowResponse = res;
      this.isLoading = false;
    });
  }

  detached() {
    this.reset();
  }

  reset() {
    this.flowResponse = null;
    this.error = null;
    this.isLoading = false;
  }
}
